module.exports = __webpack_public_path__ + "static/media/Agua.87c86c18.jpg";